module.exports = __webpack_public_path__ + "img/zs5.14489da2.png";